export default __webpack_public_path__ + "53c15b1cac6426f31a90dc1544a858a8.svg";